export const CouponRedemptionLimitActions = {
  Set: { NAME: "COUPON_REDEMPTION_LIMIT_SET" },
  Reset: { NAME: "COUPON_REDEMPTION_LIMIT_RESET" },
};